import { Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'vds-teaser-big',
  styleUrl: 'vds-teaser-big.scss',
  shadow: true,
})
export class VdsTeaserBig {

  /**
   * Headline for the Content Modules
   * Mandatory: no
   * Max Chars: 50
   */
  @Prop() headline = '';

  /**
   * Subline for the Content Module
   * Mandatory: no
   * Max Chars: 150
   */
  @Prop() subline = '';

  /**
   * Text-Content above the media element
   * Mandatory: no
   */
  @Prop() copy = '';

  render() {
    const { headline, subline, copy } = this;

    return (
      <Host>
        <div class="relative flex flex-wrap bg-white border-2 border-grey-lighter border-b-8 border-b-yellow rounded-[5px]">
          <div class="box-border sm:w-6/12 lg:w-4/12 sm:py-[50px] sm:pl-[50px] pr-0">
            <slot name="media"></slot>
          </div>
          <div class="sm:w-6/12 lg:w-8/12 p-[50px] bg-[length:57%] bg-[-45%_0] bg-no-repeat bg-image-visible">
            <h2 class="font-heavy text-h2-mobile sm:text-h2-tablet lg:text-h2-desktop text-grey uppercase break-words" innerHTML={headline}></h2>
            <h3 class="font-regular text-s2-mobile sm:text-s2-tablet lg:text-s2-desktop text-berry uppercase mt-2 break-words" innerHTML={subline}></h3>
            <p class="font-regular text-base-mobile sm:text-base-tablet lg:text-base-desktop text-grey my-7" innerHTML={copy}></p>
            <slot name="cta"></slot>
          </div>
        </div>
      </Host>
    );
  }

}
